import { render, staticRenderFns } from "./ChangeLogFeeSpe.vue?vue&type=template&id=14648b9f"
import script from "./ChangeLogFeeSpe.vue?vue&type=script&lang=js"
export * from "./ChangeLogFeeSpe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports